export default __webpack_public_path__ + "static/media/ico_success.7e2e422e.svg";